module.exports = "<p>ledger-details works!</p>\r\n"